module.exports = __webpack_public_path__ + "assets/time-down.10a49c94.svg";